import { USAStateAcronym } from '@hc-frontend/core-types';
import { z } from 'zod';

const DefaultDateRange = z.object({
  Default: z.object({
    start_date: z.string(),
    end_date: z.string(),
  }),
});

const StateDateRanges = z.record(USAStateAcronym, DefaultDateRange);

export const GetOpenEnrollmentDatesSchema =
  DefaultDateRange.and(StateDateRanges);

export type GetOpenEnrollmentDates = z.infer<
  typeof GetOpenEnrollmentDatesSchema
>;
